import { Modal } from "antd";
import { FC, useEffect } from "react";
import { postMessengerReceivedDelivery } from "tm-shared/api";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { ModalPayloads, ModalType } from "@/types/modals";
import { getFileUrl } from "@/utils/file/getFileUrl";
import { handleDownloadFile } from "@/utils/file/handleDownloadFile";

import { StyledConfirmButton } from "./Styled";

export interface ExportFileModalProps {
    payload: ModalPayloads[ModalType.Exports] | null;
    onCloseModal: () => void;
}

const ExportFileModal: FC<ExportFileModalProps> = ({
    payload,
    onCloseModal,
}) => {
    useEffect(() => {
        if (payload?.deliveryId) {
            postMessengerReceivedDelivery({
                deliveryId: payload?.deliveryId,
            });
        }
    }, [payload?.deliveryId]);

    if (!payload) return null;

    const handleConfirmExportFileModal = () => {
        handleDownloadFile(
            getFileUrl(payload.path),
            payload.filename.split(".")[0],
        );
        onCloseModal();
    };

    const handleCancelExportFileModal = () => {
        onCloseModal();
    };

    return (
        <Modal
            open
            title=""
            onCancel={handleCancelExportFileModal}
            centered
            footer={[]}
            mask={{ closable: false }}
        >
            <PrimaryText
                style={{ textAlign: "center" }}
                fontSize={20}
                fontWeight="500"
            >
                Експорт завершено
            </PrimaryText>
            <SecondaryText style={{ marginTop: "16px" }}>
                {payload?.description}
            </SecondaryText>

            <StyledConfirmButton
                type="primary"
                onClick={handleConfirmExportFileModal}
            >
                Скачати файл
            </StyledConfirmButton>
        </Modal>
    );
};

export default ExportFileModal;
